import { ChatRoom } from '@dinosband/bv-main-schema/dist/types'
import { PRIVATE_CHAT_ROOM_TYPES } from '@dinosband/bv-main-schema/dist/chat-room'
import { Store as MainStore, subscribeOnChatRoomAdded } from '@dinosband/bv-main-client'
import { BvSubscriber } from './manager/subscriber'

export class PrivateChatRoomSubscriber extends BvSubscriber<ChatRoom> {

  mainStore: MainStore
  limit?: { chatRoomIds: number[] }

  constructor (context: { mainStore: MainStore, limit?: { chatRoomIds: number[]}}, callback: (value: ChatRoom | ChatRoom[]) => void) {
    super(callback)
    this.mainStore = context.mainStore
    this.limit = context.limit
  }

  protected async query () {
    const userId = this.mainStore.userId
    if (!userId || userId <= 0) {
      return
    }
    if (this.limit) {
      return await this.mainStore.readChatRooms(this.limit.chatRoomIds)
    } else {
      return await this.mainStore.readMyPrivateChatRooms()
    }
  }

  protected async subscribe () {
    const userId = this.mainStore.userId
    if (!userId || userId <= 0) {
      return
    }
    const client = await this.mainStore.apollo.getClient()
    return subscribeOnChatRoomAdded(client, userId, PRIVATE_CHAT_ROOM_TYPES, this.callback)
  }

}
